import React from 'react';
import { Check, X } from 'lucide-react';
import { useScrollReveal } from '../hooks/useScrollReveal';
import './WhyCure8.css';

const rows = [
  {
    feature: 'Every missed call gets a response',
    sub: 'Within 60 seconds, even at midnight',
    hiring: { type: 'x' },
    agency: { type: 'x' },
    software: { type: 'x' },
    cure8: { type: 'check' },
  },
  {
    feature: 'No-shows drop by 30-40%',
    sub: 'Automated reminders that actually get read',
    hiring: { type: 'text', value: 'Manual only' },
    agency: { type: 'x' },
    software: { type: 'text', value: 'Basic only' },
    cure8: { type: 'check' },
  },
  {
    feature: 'Lapsed clients brought back automatically',
    sub: '10-25% return from a list you already own',
    hiring: { type: 'x' },
    agency: { type: 'x' },
    software: { type: 'x' },
    cure8: { type: 'check' },
  },
  {
    feature: 'Custom AI Assistant trained on your business',
    sub: 'Responds to clients like a member of your team',
    hiring: { type: 'x' },
    agency: { type: 'x' },
    software: { type: 'x' },
    cure8: { type: 'check' },
  },
  {
    feature: 'Team updates & one source of truth',
    sub: 'Announcements and schedule changes go to the right people on the right channels',
    hiring: { type: 'x' },
    agency: { type: 'x' },
    software: { type: 'text', value: 'Fragmented' },
    cure8: { type: 'check' },
  },
  {
    feature: 'Live in under 2 weeks',
    sub: 'Not months. Two weeks.',
    hiring: { type: 'text', value: '2-3 months' },
    agency: { type: 'text', value: '3-6 months' },
    software: { type: 'text', value: 'Months of setup' },
    cure8: { type: 'check' },
  },
  {
    feature: 'Zero work required from you',
    sub: 'We build it, deploy it, hand it off',
    hiring: { type: 'text', value: 'You manage them' },
    agency: { type: 'text', value: 'You review everything' },
    software: { type: 'text', value: 'You do it all' },
    cure8: { type: 'check' },
  },
  {
    feature: 'Pays for itself in month one',
    sub: 'Most clients recover the full cost within 30 days',
    hiring: { type: 'x' },
    agency: { type: 'x' },
    software: { type: 'x' },
    cure8: { type: 'check' },
  },
];

const Cell = ({ cell }) => {
  if (cell.type === 'check') {
    return (
      <span className="why-cell why-cell-check" aria-label="Included">
        <Check size={18} strokeWidth={2.5} />
      </span>
    );
  }
  if (cell.type === 'x') {
    return (
      <span className="why-cell why-cell-x" aria-label="Not included">
        <X size={18} strokeWidth={2.5} />
      </span>
    );
  }
  return <span className="why-cell why-cell-text">{cell.value}</span>;
};

const WhyCure8 = () => {
  const [ref, visible] = useScrollReveal();

  return (
    <section id="why-cure8" className="why-cure8 section">
      <div className="container">
        <div className="why-cure8-header">
          <h2 className="why-cure8-title">Why Cure8. Why Now.</h2>
          <p className="why-cure8-subtitle">
            Every other option costs more, takes longer, and leaves the work to you.
          </p>
        </div>

        <div ref={ref} className={`why-table-wrap reveal ${visible ? 'is-visible' : ''}`}>
          <table className="why-table">
            <thead>
              <tr>
                <th className="why-th-feature" scope="col" />
                <th scope="col" className="why-th">Hiring someone</th>
                <th scope="col" className="why-th">Agency</th>
                <th scope="col" className="why-th">Software</th>
                <th scope="col" className="why-th why-th-cure8">
                  <span className="why-recommended-badge">Recommended</span>
                  Cure8
                </th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row) => (
                <tr key={row.feature}>
                  <th scope="row" className="why-td-feature">
                    <span className="why-feature-title">{row.feature}</span>
                    <span className="why-feature-sub">{row.sub}</span>
                  </th>
                  <td className="why-td">
                    <Cell cell={row.hiring} />
                  </td>
                  <td className="why-td">
                    <Cell cell={row.agency} />
                  </td>
                  <td className="why-td">
                    <Cell cell={row.software} />
                  </td>
                  <td className="why-td why-td-cure8">
                    <Cell cell={row.cure8} />
                  </td>
                </tr>
              ))}
              <tr className="why-row-cost">
                <th scope="row" className="why-td-feature">
                  <span className="why-feature-title">What it costs</span>
                </th>
                <td className="why-td why-td-text">$45K-$65K/yr</td>
                <td className="why-td why-td-text">$3K-$10K/mo</td>
                <td className="why-td why-td-text">$200-$800/mo + your time</td>
                <td className="why-td why-td-cure8 why-td-price">
                  <span className="why-cure8-price">From $4,500</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
};

export default WhyCure8;
